import { Box, Typography } from "@mui/material";

const FieldValue = ({ label, value, labelWidth }) => {
  return (
    <Box
      style={styles.container}
      gap={1}
    >
      <Box sx={{ width: labelWidth ? labelWidth : "50%" }}>
        <Typography style={styles.label}>{`${label} :`}</Typography>
      </Box>
      <Typography style={styles.value}>{value}</Typography>
    </Box>
  );
};

const styles = {
  container: {
    display: "flex",
  },
  label: {
    fontSize: "12px",
    fontWeight: "bold",
  },
  value: {
    fontSize: "12px",
  },
};

export default FieldValue;
